// extracted by mini-css-extract-plugin
export default {"navBar":"NavBar_navBar__4kTTi","walletSignature":"NavBar_walletSignature__3ofWL"};